import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Survey,
  SurveyQuota,
  SurveyQuotaUpdate,
  SurveySupplierCpi,
} from '@ps/survey-utils';
import { SurveyStatus } from '@ps/survey-kernel';

export const ManageSurveyActions = createActionGroup({
  source: 'Manage Survey',
  events: {
    'Load Survey Details': props<{ surveyId: number }>(),
    'Reset Survey Details': emptyProps(),
    'Load Supplier Cpis': props<{ surveyId: number }>(),
    'Update Current Cpi': props<{ surveyId: number; cpi: number }>(),
    'Load Survey Quotas': props<{ surveyId: number; page: number }>(),
    'Load More Quotas': props<{ surveyId: number }>(),
    'Load All Quotas': props<{ surveyId: number }>(),
    'Reset Survey Quotas': emptyProps(),
    'Set Quota Lock': props<{
      surveyId: number;
      psQuotaId: string;
      locked: boolean;
    }>(),
    'Set Quota Current Target': props<{
      surveyId: number;
      psQuotaId: string;
      currentTarget: number;
      updateSupplier: boolean;
    }>(),
    'Load Traffic Channels': props<{ surveyId: number }>(),
    'Reset Traffic Channels': emptyProps(),
    'Set Traffic Channel Status': props<{
      surveyId: number;
      status: SurveyStatus;
    }>(),
  },
});

export const ManageSurveyApiActions = createActionGroup({
  source: 'Manage Survey API',
  events: {
    'Load Survey Success': props<{ survey: Survey }>(),
    'Load Survey Failure': props<{ error: string }>(),
    'Load Supplier Cpis Success': props<{
      supplierCpis: SurveySupplierCpi[];
    }>(),
    'Load Supplier Cpis Failure': props<{ error: string }>(),
    'Update Current Cpi Success': props<{ survey: Survey }>(),
    'Update Current Cpi Failure': props<{ error: string }>(),
    'Load Survey Quotas Success': props<{
      quotas: SurveyQuota[];
      total: number;
    }>(),
    'Load Survey Quotas Failure': props<{ error: string }>(),
    'Load More Quotas Success': props<{ quotas: SurveyQuota[] }>(),
    'Load More Quotas Failure': emptyProps(),
    'Load All Quotas Success': props<{ quotas: SurveyQuota[] }>(),
    'Load All Quotas Failure': emptyProps(),
    'Set Quota Lock Success': props<{ psQuotaId: string; locked: boolean }>(),
    'Set Quota Lock Failure': props<{ psQuotaId: string; error: string }>(),
    'Set Quota Current Target Success': props<{
      psQuotaId: string;
      update: SurveyQuotaUpdate;
    }>(),
    'Set Quota Current Target Failure': props<{
      psQuotaId: string;
      error: string;
    }>(),
    'Load Traffic Channels Success': props<{ trafficChannels: Survey[] }>(),
    'Load Traffic Channels Failure': props<{ error: string }>(),
    'Set Traffic Channel Status Success': props<{
      surveyId: number;
      status: SurveyStatus;
    }>(),
    'Set Traffic Channel Status Failure': props<{
      surveyId: number;
      error: string;
    }>(),
  },
});
